import { render } from "./Index copy.vue?vue&type=template&id=ca19b2d0"
import script from "./Index copy.vue?vue&type=script&lang=js"
export * from "./Index copy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/distan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__